var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.square,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_c('div',{class:_vm._.placeholder,style:({ paddingBottom: ((_vm.ratio * 100) + "%") })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }